// Vegecore theme — light interactions
(function () {
  // Mobile nav toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (t) {
      var n = document.getElementById('navLinks');
      if (n) n.classList.toggle('open');
    }
  });
  // Product gallery thumb swap
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (th) {
      var main = document.getElementById('pdpMain');
      if (main) main.src = th.getAttribute('data-full') || th.src;
    }
  });
  // Quantity stepper
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });
})();
